export function transformStructureToErrors(structureArray) {
  const errorsObject = {};

  for (const item of structureArray) {
    const { property, constraints } = item;

    const messages = [];

    for (const [constraintType, message] of Object.entries(constraints)) {
      if (message && typeof message === 'string') {
        messages.push(message);
      }
    }

    if (messages.length > 0) {
      errorsObject[property] = messages;
    }
  }

  return errorsObject;
}
